"use client";
import { jsx as a } from "react/jsx-runtime";
import { cn as t } from "../utils.js";
import { SearchBarPrimitive as c } from "@inkeep/cxkit-primitives";
const s = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarContainer,
  {
    className: t("md:min-w-[min(320px,100%)] w-full h-full min-h-9", r),
    ...e
  }
), i = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarButton,
  {
    className: t(
      "rounded-md border px-3 min-w-0 min-h-9 flex items-center justify-between gap-2 h-full w-full hover:border-gray-300 dark:hover:border-white-alpha-300 transition-colors",
      r
    ),
    ...e
  }
), m = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarContentWrapper,
  {
    className: t("flex items-center gap-2 min-w-0", r),
    ...e
  }
), l = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarText,
  {
    className: t("text-md text-gray-500 dark:text-white-alpha-600", r),
    ...e
  }
), d = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarIcon,
  {
    className: t("text-gray-500 dark:text-white-alpha-600 text-xl", r),
    ...e
  }
), p = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(
  c.SearchBarKbdWrapper,
  {
    className: t(
      "text-sm text-gray-400 dark:text-white-alpha-500 font-bold flex items-center gap-0.5",
      r
    ),
    ...e
  }
), x = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(c.SearchBarKbdModifier, { className: t("", r), ...e }), B = ({
  className: r,
  ...e
}) => /* @__PURE__ */ a(c.SearchBarKbdShortcutKey, { className: t("", r), ...e });
export {
  i as SearchBarButton,
  s as SearchBarContainer,
  m as SearchBarContentWrapper,
  d as SearchBarIcon,
  x as SearchBarKbdModifier,
  B as SearchBarKbdShortcutKey,
  p as SearchBarKbdWrapper,
  l as SearchBarText
};
